import BaseConst from "./BaseConst";

/**
 *
 */
export default class BroadcastMessage {
  action: string;
  uuid: string;
  topicId: string;
  sort: number;
  message: string;
  height: number;

  constructor(action: string, uuid: string, topicId: string, sort: number = BaseConst.SORT_ASC, height: number = 0, message: string = '') {
    this.action = action;
    this.uuid = uuid;
    this.topicId = topicId;
    this.sort = sort;
    this.height = height;
    this.message = message;
  }
}
